/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorDeleteEditsMutationResponse, VideoEditorDeleteEditsPathParams, VideoEditorDeleteEdits401, VideoEditorDeleteEdits403 } from "../models/VideoEditorDeleteEdits";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { videoEditorDeleteEdits } from "../axios/videoEditorDeleteEdits";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const videoEditorDeleteEditsMutationKey = () => [{ url: '/video-editor/v1/edits/:id' }] as const

export type VideoEditorDeleteEditsMutationKey = ReturnType<typeof videoEditorDeleteEditsMutationKey>

export function videoEditorDeleteEditsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = videoEditorDeleteEditsMutationKey()
        return mutationOptions<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, {id: VideoEditorDeleteEditsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return videoEditorDeleteEdits(id, config)
          },
        })

}

/**
 * @summary Delete a project
 * {@link /video-editor/v1/edits/:id}
 */
export function useVideoEditorDeleteEdits<TContext>(options: 
{
  mutation?: UseMutationOptions<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, {id: VideoEditorDeleteEditsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? videoEditorDeleteEditsMutationKey()

          const baseOptions = videoEditorDeleteEditsMutationOptions(config) as UseMutationOptions<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, {id: VideoEditorDeleteEditsPathParams["id"]}, TContext>
          

          return useMutation<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, {id: VideoEditorDeleteEditsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<VideoEditorDeleteEditsMutationResponse, ResponseErrorConfig<VideoEditorDeleteEdits401 | VideoEditorDeleteEdits403>, {id: VideoEditorDeleteEditsPathParams["id"]}, TContext>
      
}